import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
import { costs, faqs, purchases } from '../data/offer';
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-20" data-mp="3pixq87cpa3tv">
        <div className="mx-auto max-w-3xl text-center" data-id="element-21" data-mp="3bskio63q0r52">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-22" data-mp="3br13yjxpqo5e" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-23" data-mp="3glx7ag8egxxt">
            GARANTÍA 30 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-24" data-mp="36trex5e8kei3">
            <p className="text-slate-300" data-id="element-25" data-mp="2su876dpc756b">Seguís las fases. Ordenás tus comidas. Observás el proceso.</p>
            <p className="mt-4 text-slate-300" data-id="element-26" data-mp="2wvlhazzgpuj1">
              Si en 30 días no es lo que esperabas, te devolvemos el 100%.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-27" data-mp="2fqidic8gkiov">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-28" data-mp="2av35i0x4th0d">sin formularios, sin drama.</p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-29" data-mp="2pnn1mhlv6o8b">Tasa de devoluciones: menos del 1%.</p>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-30" data-mp="1x12a9h5e2c4r">
        <div className="mx-auto max-w-3xl" data-id="element-31" data-mp="1wz7pq3y14m17">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-32" data-mp="1s2r015b6lzm0">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-33" data-mp="26rww4keq39po">
            {faqs.map(([question, answer], index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-34" data-mp="1ea12q4q7d89l" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-35" data-mp="1yzv7mpa82a43">
                    <span data-id="element-36" data-mp="2cqi8amzjma2t">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-37" data-mp="1g1alzcr3nwxu" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-38" data-mp="1u1tq48sg2iuq">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-39" data-mp="30hnq37p1ncfr">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-40" data-mp="ovvafti7dle0">
                          {answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-41" data-mp="13yaazo48hsq">
      <div className="mx-auto max-w-4xl" data-id="element-42" data-mp="14ga269zle5e">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-43" data-mp="3sahf9y79tdj4">
          ⚖️ ¿CUÁNTO CUESTA NO TENER EL SISTEMA?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-44" data-mp="1vh67gxzkd5hj">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-45" data-mp="1qh1q75qu06q9">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-46" data-mp="23gkmp4epajkq">
                ×
              </span>
              {item}
            </p>)}
        </div>
        <p className="mt-12 text-center text-xl font-bold" data-id="element-47" data-mp="1tj65v3ov7srw">El próximo lunes puede ser diferente.</p>
        <p className="mx-auto mt-5 max-w-3xl text-center font-display text-xl font-bold italic text-brand-light sm:text-2xl" data-id="element-48" data-mp="1fsau9jmzexkm">
          “Tu intestino no está roto. Está esperando el orden correcto.” 🌿
        </p>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-49" data-mp="d8yazj3p8vzd">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-50" data-mp="r7y2qzmidqzr">
          PROTOCOLO RESCATE SIBO™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-51" data-mp="116433cso2p2i">
          El sistema de 3 fases para desinflamar el abdomen y recuperar tu
          digestión, paso a paso.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-52" data-mp="19yfr6s0b60fb">
          Porque tu intestino no está roto. Está esperando el orden correcto.
        </p>

        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-53" data-mp="15xvqxfkfugoy">
          <a className="hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-54" data-mp="1jur4nlbmwwbc">
            📧 soportebiomalivido@gmail.com
          </a>
          <a className="hover:text-brand-light" href="https://www.instagram.com/biomalivido/" target="_blank" rel="noreferrer" data-id="element-55" data-mp="cl5kx1zjx8fd">
            📲 @biomalivido
          </a>
          <a className="hover:text-brand-light" href="https://www.biomalivido.com" target="_blank" rel="noreferrer" data-id="element-56" data-mp="ljhkhtiebgjy">
            🌐 biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-57" data-mp="vd6oghn9tmv4">
          © PROTOCOLO RESCATE SIBO™ 2026 — Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-58" data-mp="14cttrej4fctg">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-59" data-mp="19amye34rzyrm">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-60" data-mp="2yrqvtqddtjuj">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="2tse7t2ary6qd" />
              Acceso confirmado
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-62" data-mp="2oum7bjw2dcak">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-slate-300" data-id="element-63" data-mp="3mgjtbr9njzr9">adquirió Protocolo Rescate SIBO™</p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-64" data-mp="3hirs26n4b1ae">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}